/* 
 * This file is part of Tibia Wheel.
 * Copyright (c) 2022 Maciej Sopyło
 * 
 * Tibia Wheel is free software: you can redistribute it and/or modify  
 * it under the terms of the GNU Lesser General Public License as published by  
 * the Free Software Foundation, version 3.
 *
 * Tibia Wheel is distributed in the hope that it will be useful, but 
 * WITHOUT ANY WARRANTY; without even the implied warranty of 
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU 
 * General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License 
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

 .widget {
  border-image: url(../../assets/widget-borderimage.png?as=webp);
  border-image-slice: 15 4 4;
  border-image-repeat: repeat;
  border-style: solid;
  border-width: 4px;
  border-top-width: 18px;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  gap: 0.5rem;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);

  & > span:first-child {
    font-size: 0.75rem;
    margin-top: -1.55rem;
    margin-left: -0.25rem;
    color: #ded2ac;
    text-shadow: 1px 1px #111;
  }
}
